import { Link } from 'react-router-dom';

export default function ForAgentsPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-essence-teal">
        For AI agents
      </p>
      <h1 className="mt-3 max-w-3xl font-display text-4xl font-bold tracking-tight text-essence-ink sm:text-5xl">
        Settlement for agent payments on Base
      </h1>
      <p className="mt-5 max-w-2xl text-lg leading-relaxed text-essence-mute">
        Essence is a Base ERC-20 stablecoin AI agents can use to pay for goods and services — other agents,
        APIs, or merchants that accept ESSENCE. Payment is a core intended use of the token. In SELF OS, agents
        are designed as economic participants, not passive chat windows.
      </p>

      <ul className="mt-14 space-y-0">
        {[
          {
            title: 'Agent spend',
            body: 'Transfer and settle Essence on Base for goods, services, and agent-to-agent payments. Acceptance is by counterparties that choose to take Essence — not a claim that every merchant is live.',
          },
          {
            title: 'Policy-based delegation',
            body: 'SELF OS intends humans to set budgets and permissions while agents execute inside those limits — so microtransactions do not require click-approve for every step. Architecture direction; tooling is still rolling out.',
          },
          {
            title: 'Workload settlement',
            body: 'Meter inference and other agent workloads in the same unit. Balances are portable across runs.',
          },
          {
            title: 'Hold or exit to USDC',
            body: 'Sellers can hold Essence or exit toward USDC via the existing treasury deposit/withdraw rail. Redeemability depends on an ops-funded vault — not FDIC, not a bank deposit, and not a guarantee the vault is fully funded today.',
          },
        ].map((item) => (
          <li key={item.title} className="border-t border-essence-line py-7">
            <h2 className="font-display text-xl font-semibold text-essence-ink sm:text-2xl">{item.title}</h2>
            <p className="mt-2 max-w-2xl text-base leading-relaxed text-essence-mute">{item.body}</p>
          </li>
        ))}
      </ul>

      <p className="mt-10 max-w-2xl border-l-2 border-essence-teal/50 pl-5 text-sm leading-relaxed text-essence-mute">
        On-chain transfers settle today. That does not mean a shopping marketplace is live, or that all merchants
        accept Essence. Micropayments, marketplace checkout, and machine commerce remain platform direction.
      </p>

      <div className="mt-10 flex flex-wrap gap-3">
        <Link
          to="/economy"
          className="inline-flex rounded-lg bg-essence-teal px-5 py-3 text-sm font-semibold text-white hover:bg-essence-teal-bright"
        >
          Economic layer
        </Link>
        <Link
          to="/how-it-works"
          className="inline-flex rounded-lg border border-essence-line px-5 py-3 text-sm font-semibold text-essence-ink hover:border-essence-gold/40"
        >
          How money enters
        </Link>
        <Link
          to="/contracts"
          className="inline-flex rounded-lg border border-essence-line px-5 py-3 text-sm font-semibold text-essence-ink hover:border-essence-gold/40"
        >
          Contracts
        </Link>
      </div>
    </div>
  );
}
